import { useEffect } from 'react';

import { ENUMS } from 'services/consts';

import { FilterAction, FilterType } from '../components/list/DynamicListFilterUtils';

/**
 * Custom hook to update extra filters for brand managers.
 * @param {boolean} isBrandManager - Whether the user is a brand manager.
 * @param {Array} assignedBrands - List of assigned brand objects.
 * @param {Function} setExtraFilters - State setter for extra filters.
 */
const useBrandManagerFilter = ({ isBrandManager, assignedBrands, setExtraFilters }) => {
	useEffect(() => {
		if (isBrandManager) {
			setExtraFilters((prev) => {
				const brandFilterIndex = prev.findIndex((filter) => filter.label === 'brand');
				const defaultBrandValue = assignedBrands.map((brand) => brand.name);
				if (brandFilterIndex !== -1) {
					const updatedFilters = [...prev];
					updatedFilters[brandFilterIndex] = {
						...updatedFilters[brandFilterIndex],
						enumProps: {
							...updatedFilters[brandFilterIndex].enumProps,
							valueRemovable: false
						},
						filterValues: {
							...updatedFilters[brandFilterIndex].filterValues,
							value: defaultBrandValue
						}
					};
					return updatedFilters;
				}
				return [
					...prev,
					{
						label: 'brand',
						type: 'enum',
						enumProps: {
							enumName: ENUMS.ASSIGNED_BRANDS,
							multipleSelection: true,
							valueRemovable: false
						},
						filterValues: {
							key: ['brand'],
							action: FilterAction.is,
							filterType: FilterType.enumMulti,
							value: defaultBrandValue
						}
					}
				];
			});
		}
	}, [isBrandManager, assignedBrands, setExtraFilters]);
};

export default useBrandManagerFilter;
